import { useState } from 'react';
import DateFunc from '@/lib/lyg/date_func';
import RowArea from "./row";
import strFunc from '@/lib/lyg/string';

function ListArea(props: any) {
  let myProps = {
    xColumnArr: [],
    infoArr: [],
    setInfoArr: (inData: any) => { },
    select_seq_arr: [],
    set_select_seq_arr: (inData: any) => { },
    select_use_seq_arr: [],
    set_select_use_seq_arr: (inData: any) => { },
    select_show_write_page: (inData: any) => { },
    order_det_arr: [],
    select_order_det_seq_arr: [],
    set_select_order_det_seq_arr: (inData: any) => { },
    is_show_all_book:false,
    delete_order_by_ajax: (inData: any) => { },
    delete_textbook_use_by_ajax: (inData: any) => { },
    go_use_of_order_det_by_ajax: (inData: any) => { },
    go_add_order_period_by_ajax: (inData: any) => { },
    send_payt_cancel_by_ajax: (inData: any) => { },
    send_payt_send_read_by_ajax: (inData: any) => { },
    open_request_order_popup: (inData: any) => { },
    open_find_textbook_each_order_popup: (inData: any) => { },
    ...props
  };
  let infoArr = myProps.infoArr;
  let xColumnArr = myProps.xColumnArr;

  let now_y_m_d = DateFunc.get_date_format(new Date(), "Y-m-d");
  const [order_book_data, set_order_book_data] = useState<any>({
    key: "",
    asc_desc: ""
  });

  const check_all = (e: any) => {
    let new_select_seq_arr: any = [];
    if (e.target.checked === false) {
      myProps.set_select_seq_arr(new_select_seq_arr);
      return;
    }
    infoArr.map((info: any, idx: number) => {
      new_select_seq_arr.push(info["a_seq"]);
    });
    myProps.set_select_seq_arr(new_select_seq_arr);
  };

  const set_order_by_key = (inData: any) => {
    let opt_obj = {
      key: "",
      ...inData
    };
    let key = opt_obj.key;
    let change_order_book_data = {
      ...order_book_data,
      key: opt_obj.key,
      asc_desc: ""
    };
    if (order_book_data.key == key) {
      if (order_book_data.asc_desc == "") {
        change_order_book_data.asc_desc = "desc";
      } else {
        change_order_book_data.asc_desc = "";
      }
    }
    set_order_book_data(change_order_book_data);

    if (opt_obj.key == "period") {
      set_order_by_period({
        key: change_order_book_data.key,
        asc_desc: change_order_book_data.asc_desc
      });
    }
  };

  const set_order_by_period = (inData: any) => {
    let opt_obj = {
      key: order_book_data.key,
      asc_desc: order_book_data.asc_desc,
      ...inData
    };
    let key = opt_obj.key;
    let asc_desc = opt_obj.asc_desc;
    let sorted_info_arr = [...infoArr];

    let end_date_arr = [];
    let end_date_json_arr: any = {};

    for (let i = 0; i < sorted_info_arr.length; i++) {
      let info = sorted_info_arr[i];
      if (info.textbook_use_arr) {
        for (let p_i = 0; p_i < info.textbook_use_arr.length; p_i++) {
          let use_info = info.textbook_use_arr[p_i];
          if (!strFunc.is_empty(use_info.a_period_end_date) && use_info.a_period_end_date.substring(0, 4) != "0000") {
            if (use_info.a_period_end_date >= now_y_m_d) {
              let row_period_end_date = strFunc.uncomma_int(strFunc.getNumber2(use_info.a_period_end_date));
              if (strFunc.str_in_array(row_period_end_date, end_date_arr) == -1) {
                end_date_arr.push(row_period_end_date);
              }
            }
          }
        }
      }
    }
    end_date_arr.sort();
    if (asc_desc == "desc") {
      end_date_arr.reverse();
    }

    let added_seq_arr = [];
    for (let end_i = 0; end_i < end_date_arr.length; end_i++) {
      let end_date_str = end_date_arr[end_i];
      end_date_json_arr[end_date_str] = [];

      for (let i = 0; i < sorted_info_arr.length; i++) {
        let info = sorted_info_arr[i];
        let is_exist_period = false;
        if (info.textbook_use_arr) {
          for (let p_i = 0; p_i < info.textbook_use_arr.length; p_i++) {
            let use_info = info.textbook_use_arr[p_i];
            if (!strFunc.is_empty(use_info.a_period_end_date) && use_info.a_period_end_date.substring(0, 4) != "0000") {
              if (use_info.a_period_end_date >= now_y_m_d) {
                let row_period_end_date = strFunc.uncomma_int(strFunc.getNumber2(use_info.a_period_end_date));
                if (row_period_end_date == end_date_str) {
                  is_exist_period = true;
                }
              }
            }
          }
        }
        if (is_exist_period) {
          if (strFunc.str_in_array(info.a_seq, added_seq_arr) == -1) {
            end_date_json_arr[end_date_str].push(info);
            added_seq_arr.push(info.a_seq);
          }
        }
      }
    }

    sorted_info_arr = [];
    for (let end_i = 0; end_i < end_date_arr.length; end_i++) {
      let end_date_str = end_date_arr[end_i];
      if (end_date_json_arr[end_date_str]) {
        sorted_info_arr = [
          ...sorted_info_arr,
          ...end_date_json_arr[end_date_str]
        ];
      }
    }

    myProps.setInfoArr(sorted_info_arr);
  };

  const get_row_tags = () => {
    let row_tags: any = infoArr.map((info: any, idx: number) => {
      return (
        <RowArea
          key={idx}
          info={info}
          row_num={idx}
          xColumnArr={xColumnArr}
          select_seq_arr={myProps.select_seq_arr}
          set_select_seq_arr={myProps.set_select_seq_arr}
          select_show_write_page={myProps.select_show_write_page}
          order_det_arr={myProps.order_det_arr}
          select_order_det_seq_arr={myProps.select_order_det_seq_arr}
          set_select_order_det_seq_arr={myProps.set_select_order_det_seq_arr}
          is_show_all_book={myProps.is_show_all_book}
          delete_order_by_ajax={myProps.delete_order_by_ajax}
          delete_textbook_use_by_ajax={myProps.delete_textbook_use_by_ajax}
          go_use_of_order_det_by_ajax={myProps.go_use_of_order_det_by_ajax}
          go_add_order_period_by_ajax={myProps.go_add_order_period_by_ajax}
          send_payt_cancel_by_ajax={myProps.send_payt_cancel_by_ajax}
          send_payt_send_read_by_ajax={myProps.send_payt_send_read_by_ajax}
          open_request_order_popup={myProps.open_request_order_popup}
          open_find_textbook_each_order_popup={myProps.open_find_textbook_each_order_popup}
        />
      );
    });

    return row_tags;
  };

  return (
    <div className="basic_list_div">
      <table>
        <colgroup>
          <col style={{ width: "1%" }} />
          {xColumnArr.x_column_list_arr.map((column: any, idx: number) => (
            <col key={idx} style={{ width: column["width"] + "%" }} />
          ))}
        </colgroup>
        <thead>
          <tr>
            <th>
              <div className="row-col-div">
                <input type="checkbox" onChange={(e) => { check_all(e) }} name="check_all" value="" style={{ width: 20, height: 20 }} />
              </div>
            </th>
            {xColumnArr.x_column_list_arr.map((column: any, idx: number) => (
              <th key={idx}>
                <div className="row-col-div">
                  {column["name"]}
                </div>
                {column["key"] == "row_view_order_manage" &&
                  <div>
                    <table>
                      <colgroup>
                        <col style={{ width: "30%" }} />
                        <col style={{ width: "20%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "15%" }} />
                        {/* <col style={{ width: "10%" }} /> */}
                      </colgroup>
                      <thead>
                        <tr style={{ border: "0px" }}>
                          <th>교재</th>
                          <th>기간</th>
                          <th style={{ cursor: "pointer" }} onClick={() => { set_order_by_key({ "key": "period" }); }}>
                            잔여일
                          </th>
                          <th>
                            신규주문
                          </th>
                          <th>
                            관리
                          </th>
                          {/* <th>
                            상태
                          </th> */}
                        </tr>
                      </thead>
                    </table>
                  </div>
                }
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {get_row_tags()}
        </tbody>
      </table>
    </div>
  );
};
export default ListArea;